import React from 'react'

export const Button = ({
  className,
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <>
      <button
        className={`p-[6px_12px] h-[24] md:h-[32px] shadow-[0px_1px_4px_0px_rgba(0,0,0,0.25)] font-medium rounded-[6px] leading-[20px] text-[12px] md:text-[16px] ${className}`}
        {...props}
      >
        {children}
      </button>
    </>
  )
}
